module.exports = __webpack_public_path__ + "static/media/projectPic2.d4af16f7.png";